<template>
  <div class="endetzxaj">
    <div class="zxajhed between">
      <div class="zxajtitl flex_start">
        <img src="../../../assets/entrust/zxanjianicon.png" />
        最新案件
      </div>
      <div class="mo">更多>></div>
    </div>
    <div class="anjianlist">
      <div class="anjianitem between" v-for="item in 7" :key="item">
        <div class="anjianbt ellipsis">
          交通事故肇事司机全责，我方人员脸部缝针15针
        </div>
        <div class="anjiantime">2021-04-02</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.endetzxaj {
  padding: 30px 28px;
  .zxajhed {
    .zxajtitl {
      font-size: 20px;
      color: #333333;
      img {
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
    }
    .mo {
      cursor: pointer;
      font-size: 16px;
      color: #0465ea;
    }
  }
  .anjianlist {
    padding-top: 10px;
    font-size: 16px;
    color: #666666;
    .anjianitem {
      margin-top: 18px;
      .anjianbt {
        width: 670px;
      }
      &:hover {
        color: #0465ea;
      }
    }
  }
}
</style>